export const cols = [
  {
    key: 'imageId',
    title: '素材ID',
    width: 78
  },
  {
    key: 'addr',
    title: '素材',
    width: 120
  },
  {
    key: 'imageName',
    title: '素材名称',
    width: 220
  },
  {
    key: 'type',
    title: '素材类型',
    width: 100
  },
  {
    key: 'labelNames',
    title: '素材样式',
    width: 200
  },

  {
    key: 'mediaTagName',
    title: '媒体标签',
    width: 200
  },
  {
    key: 'designerName',
    title: '设计者'
  },
  {
    key: 'uploadTime',
    title: '上传时间',
    width: 228
  }
]
